/* unplugin-vue-components disabled */import script from "./SendCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./SendCoupon.vue?vue&type=script&setup=true&lang=js"

import "./SendCoupon.vue?vue&type=style&index=0&id=25a5e78a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a5e78a"]])

export default __exports__